module.exports = __webpack_public_path__ + "img/blog.7781c13d.webp";